import { render } from "./LearningPath.vue?vue&type=template&id=6dc4ea09"
import script from "./LearningPath.vue?vue&type=script&lang=js"
export * from "./LearningPath.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__